export default __webpack_public_path__ + "static/media/CliniMACS_Prodigy_ACC_MSC_expansion_Appsheet.452759dc.pdf";